import { FETCH_POST_SUCCESS } from '../actions/fetch-post';
import { FETCH_POSTS_SUCCESS } from '../actions/fetch-posts';
import { FETCH_USER_POSTS_SUCCESS } from '../actions/fetch-posts-by-owner-id';
import { FETCH_SEARCH_SUCCESS } from '../actions/fetch-search';
import { UPDATE_POST_SUCCESS } from '../actions/update-post';
import { SET_CATEGORIES } from '../actions/set-categories';
import { DELETE_POST_SUCCESS } from '../actions/delete-post';
import { CREATE_POST_SUCCESS } from '../actions/create-post';
import { MOVE_POST_SUCCESS } from '../actions/move-post';
import { PIN_POST_SUCCESS } from '../actions/pin-post';
import { UNPIN_POST_SUCCESS } from '../actions/unpin-post';
import { ADD_TOP_COMMENT_SUCCESS } from '../actions/add-top-comment';
import { REMOVE_TOP_COMMENT_SUCCESS } from '../actions/remove-top-comment';
import { ENABLE_POST_COMMENTS_SUCCESS } from '../actions/enable-post-comments';
import { DISABLE_POST_COMMENTS_SUCCESS } from '../actions/disable-post-comments';
import { SUBSCRIBE_REQUEST, SUBSCRIBE_FAILURE } from '../actions/subscribe';
import { UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_FAILURE } from '../actions/unsubscribe';
import {
  INCREMENT_POST_LIKE_COUNT_REQUEST,
  INCREMENT_POST_LIKE_COUNT_SUCCESS,
  INCREMENT_POST_LIKE_COUNT_FAILURE,
} from '../actions/increment-post-like-count';
import { PROMOTE_MODERATOR_SUCCESS } from '../actions/promote-moderator';
import { DEMOTE_MODERATOR_SUCCESS } from '../actions/demote-moderator';
import { USER_SET_PERMISSIONS } from '../actions/user-socket';
import { UPDATE_USER_SUCCESS } from '../actions/update-user';
import { BLOCK_USER_SUCCESS } from '../actions/block-user';
import { UNBLOCK_USER_SUCCESS } from '../actions/unblock-user';
import { NEW_POST, UPDATE_POST_COUNTERS } from '../actions/category-socket';
import { UPDATE_POST } from '../actions/post-socket';
import { DELETE_COMMENT_SUCCESS } from '../actions/delete-comment';
import _ from 'lodash';

// eslint-disable-next-line complexity
const post = (state, action) => {
  switch (action.type) {
    case SUBSCRIBE_REQUEST:
      if (state._id === action.payload._id) {
        return { ...state, isSubscribed: true };
      }
      return state;
    case SUBSCRIBE_FAILURE:
      if (state._id === action.payload._id) {
        return { ...state, isSubscribed: false };
      }
      return state;
    case UNSUBSCRIBE_REQUEST:
      if (state._id === action.payload._id) {
        return { ...state, isSubscribed: false };
      }
      return state;
    case UNSUBSCRIBE_FAILURE:
      if (state._id === action.payload._id) {
        return { ...state, isSubscribed: true };
      }
      return state;
    case INCREMENT_POST_LIKE_COUNT_REQUEST:
      if (state._id === action.payload._id) {
        return {
          ...state,
          isLiked: !state.isLiked,
          likeCount: state.likeCount + (state.isLiked ? -1 : 1),
          isLikeInProgress: true,
        };
      }
      return state;
    case INCREMENT_POST_LIKE_COUNT_SUCCESS:
      if (state._id === action.payload._id) {
        return _.omit({ ...state, ...action.payload }, 'isLikeInProgress');
      }
      return state;
    case INCREMENT_POST_LIKE_COUNT_FAILURE:
      if (state._id === action.payload._id) {
        return _.omit(
          {
            ...state,
            isLiked: !state.isLiked,
          },
          'isLikeInProgress'
        );
      }
      return state;
    case PROMOTE_MODERATOR_SUCCESS:
    case DEMOTE_MODERATOR_SUCCESS:
    case USER_SET_PERMISSIONS:
    case UPDATE_USER_SUCCESS:
    case BLOCK_USER_SUCCESS:
    case UNBLOCK_USER_SUCCESS:
      if (state.owner._id === action.payload._id) {
        return { ...state, owner: action.payload };
      }
      return state;
    case DELETE_COMMENT_SUCCESS:
      if (state.topCommentId === action.payload._id) {
        return { ...state, topCommentId: null };
      }
      return state;
    default:
      return state;
  }
};

// eslint-disable-next-line complexity
export default (state = {}, { type, payload } = {}) => {
  switch (type) {
    case FETCH_POST_SUCCESS:
      return unionPosts(state, [payload.post]);
    case FETCH_USER_POSTS_SUCCESS:
    case FETCH_POSTS_SUCCESS:
      return unionPosts(state, payload);
    case UPDATE_POST:
    case UPDATE_POST_SUCCESS:
    case MOVE_POST_SUCCESS:
    case PIN_POST_SUCCESS:
    case UNPIN_POST_SUCCESS:
    case ADD_TOP_COMMENT_SUCCESS:
    case REMOVE_TOP_COMMENT_SUCCESS:
    case ENABLE_POST_COMMENTS_SUCCESS:
    case DISABLE_POST_COMMENTS_SUCCESS:
      return unionPosts(state, [payload]);
    case NEW_POST:
    case CREATE_POST_SUCCESS:
      return unionPosts(state, [payload]);
    case FETCH_SEARCH_SUCCESS:
      return unionPosts(state, payload.posts.filter(post => post.type === 'post'));
    case SET_CATEGORIES: {
      const categoryIds = payload.map(category => category._id);
      return _.omitBy(state, post => categoryIds.indexOf(post.categoryId) === -1);
    }
    case DELETE_POST_SUCCESS:
      return _.omit(state, payload);
    case SUBSCRIBE_REQUEST:
    case SUBSCRIBE_FAILURE:
    case UNSUBSCRIBE_REQUEST:
    case UNSUBSCRIBE_FAILURE:
      if (payload.type === 'post') {
        return Object.keys(state).reduce((result, current) => {
          result[current] = post(state[current], { type, payload });
          return result;
        }, {});
      }
      return state;
    case INCREMENT_POST_LIKE_COUNT_SUCCESS:
      return Object.keys(state).reduce((result, current) => {
        result[current] = post(state[current], { type, payload });
        return result;
      }, {});
    case INCREMENT_POST_LIKE_COUNT_FAILURE:
      return Object.keys(state).reduce((result, current) => {
        result[current] = post(state[current], { type, payload });
        return result;
      }, {});
    case INCREMENT_POST_LIKE_COUNT_REQUEST:
      return Object.keys(state).reduce((result, current) => {
        result[current] = post(state[current], { type, payload });
        return result;
      }, {});
    case PROMOTE_MODERATOR_SUCCESS:
    case DEMOTE_MODERATOR_SUCCESS:
    case USER_SET_PERMISSIONS:
    case UPDATE_USER_SUCCESS:
    case BLOCK_USER_SUCCESS:
    case UNBLOCK_USER_SUCCESS:
    case DELETE_COMMENT_SUCCESS:
      return Object.keys(state).reduce((result, current) => {
        result[current] = post(state[current], { type, payload });
        return result;
      }, {});
    case UPDATE_POST_COUNTERS:
      return { ...state, [payload._id]: { ...state[payload._id], ...payload } };
    default:
      return state;
  }
};

function unionPosts(oldPosts, newPosts) {
  return newPosts.reduce(
    (result, post) => {
      result[post._id] = post;
      return result;
    },
    { ...oldPosts }
  );
}



// WEBPACK FOOTER //
// ./app/reducers/posts.js